/* eslint-disable no-console */
import ScratchStorage from 'scratch-storage';
import nets from 'nets';
import defaultProject from './default-project';
import {
    getUserToken
} from './services/query-params';
import {
    getOssSign,
    upload
} from './services/scratch-ser';
import batchToRun from './batchToRun';
import {
    unit8ArryToFile
} from './transfer-format';
import {addURLParams} from './query-string';
import {messyParams} from './messy-params';


/**
 * Wrapper for ScratchStorage which adds default web sources.
 * @todo make this more configurable
 */
class Storage extends ScratchStorage {
    constructor () {
        super();
        this.cacheDefaultProject();
        // setTimeout(() => {
        this.webHelper.load = function (assetType, assetId, dataFormat) {
            /** @type {Array.<{url:string, result:*}>} List of URLs attempted & errors encountered. */
            const errors = [];
            const stores = this.stores.slice();
            const asset = new this.parent.Asset(assetType, assetId, dataFormat);
            let storeIndex = 0;
            const parent = this.parent;
            // 造型/声音缺失时用内置占位，避免整项目 loadProject 失败；工程 JSON / Project 仍按原逻辑失败
            const canUsePlaceholder = [
                parent.AssetType.ImageBitmap,
                parent.AssetType.ImageVector,
                parent.AssetType.Sound
            ].indexOf(assetType) !== -1;

            return new Promise((resolve, reject) => {

                const resolveWithPlaceholder = () => {
                    const defaultId = parent.defaultAssetId[assetType.name];
                    const defaultAsset = defaultId && parent.get(defaultId);
                    if (!defaultAsset || !defaultAsset.data) {
                        reject(errors.length ? errors : new Error(`asset not found: ${assetId}`));
                        return;
                    }
                    // 保留原 assetId，仅替换二进制，避免保存时污染成默认资源 md5
                    asset.setData(defaultAsset.data, defaultAsset.dataFormat || dataFormat);
                    // eslint-disable-next-line no-console
                    console.warn(
                        '[scratch-storage] asset load failed, using placeholder',
                        assetType && assetType.name,
                        assetId,
                        errors
                    );
                    resolve(asset);
                };

                const tryNextSource = () => {

                    /** @type {UrlFunction} */
                    let reqConfigFunction;

                    while (storeIndex < stores.length) {
                        const store = stores[storeIndex];
                        ++storeIndex;
                        if (store.types.indexOf(assetType.name) >= 0) {
                            reqConfigFunction = store.get;
                            break;
                        }
                    }

                    if (reqConfigFunction) {
                        let reqConfig = reqConfigFunction(asset);
                        if (reqConfig === false) {
                            tryNextSource();
                            return;
                        }
                        if (typeof reqConfig === 'string') {
                            reqConfig = {
                                url: reqConfig
                            };
                        }

                        nets(Object.assign({
                            method: 'get'
                        }, reqConfig), (err, resp, body) => {
                            // body is a Buffer
                            if (err || Math.floor(resp.statusCode / 100) !== 2) {
                                let errorJson = {

                                };
                                if (body instanceof Uint8Array) {
                                    try {
                                        errorJson = JSON.parse(new TextDecoder('utf-8').decode(body));
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }
                                if (!err && resp.rawRequest) {
                                    err = {
                                        status: errorJson.status || resp.rawRequest.status,
                                        statusText: errorJson.message || resp.rawRequest.statusText,
                                        asset: asset.decodeText()
                                    };
                                }
                                errors.push(err || (resp && resp.statusCode) || 'load failed');
                                tryNextSource();
                            } else {
                                asset.setData(body, dataFormat);
                                resolve(asset);
                            }
                        });
                        return;
                    }
                    if (errors.length > 0) {
                        if (canUsePlaceholder) {
                            resolveWithPlaceholder();
                        } else {
                            reject(errors);
                        }
                    } else if (!reqConfigFunction) {
                        if (canUsePlaceholder) {
                            resolveWithPlaceholder();
                        } else {
                            resolve(null); // no stores matching asset
                        }
                    }
                };

                tryNextSource();
            });
        };
        // }, 100);
        
    }
    addOfficialScratchWebStores () {
        this.addWebStore(
            [this.AssetType.Project],
            this.getProjectGetConfig.bind(this),
            this.getProjectCreateConfig.bind(this),
            this.getProjectUpdateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.ImageVector, this.AssetType.ImageBitmap, this.AssetType.Sound],
            this.getAssetGetConfig.bind(this),
            // We set both the create and update configs to the same method because
            // storage assumes it should update if there is an assetId, but the
            // asset store uses the assetId as part of the create URI.
            this.getAssetCreateConfig.bind(this),
            this.getAssetUpdateConfig.bind(this)
        );
        this.addWebStore(
            [this.AssetType.Sound],
            asset => {
                const id = String(asset.assetId || '');
                // 用户上传：assetId 为 OSS 路径编码（含 &&），勿拼 music 扩展目录
                if (id.indexOf('&&') !== -1 || id.indexOf('/') !== -1) {
                    return false;
                }
                return `static/extension-assets/scratch3_music/${asset.assetId}.${asset.dataFormat}`;
            }
        );
    }
    setProjectHost (projectHost) {
        this.projectHost = projectHost;
    }
    getProjectGetConfig (projectAsset) {
        const {category} = messyParams;
        const path = category === '3' ? 'projects' : 'getScratchExercise';

        // eslint-disable-next-line prefer-const
        let params = {
            id: projectAsset.assetId
        };
        const url = addURLParams(
            `${this.projectHost}/${path}`,
            params
        );
        const urlTemp = addURLParams(
            `${API_BASE_URL}/community/admin/creation/template/scratch/detail`,
            params
        );
        
        return {
            url: category === '3' ? urlTemp : url,
            headers: {
                Authorization: getUserToken() || ''
            }
        };
    }
    // PENGJU S2接口
    getProjectCreateConfig () {
        const {category, fr} = messyParams;

        // 保存模板
        if (category === '3' && fr !== 'tr') {
            return `${API_BASE_URL}/community/admin/creation/template/scratch/save`;
        }

        // 保存作业
        return `${this.projectHost}/saveScratchExercise`;
    }
    
    getProjectUpdateConfig () {
        return {
            method: 'put',
            url: `${this.projectHost}/projects/`
        };
    }
  
    setAssetHost (assetHost) {
        this.assetHost = assetHost;
    }
    getAssetGetConfig (asset) {
        let assetHost = this.assetHost || '';
        if (assetHost.startsWith('//')) {
            assetHost = window.location.protocol + assetHost;
        }
        const fileUrl = (asset.assetId && asset.assetId.replace(/&&/g, '/')) || '';
        if (fileUrl.indexOf('/') === -1) {
            return {
                url: `${assetHost}/common/mit/${fileUrl}.${asset.dataFormat}`
            };
        }
        const cdnRoot = assetHost.replace(/\/scratch-res(-test|-dev)?\/?$/, '');
        const hasExt = /\.[a-z0-9]+$/i.test(fileUrl);
        return {
            url: hasExt ? `${cdnRoot}/${fileUrl}` : `${cdnRoot}/${fileUrl}.${asset.dataFormat}`
        };
    }
    getAssetCreateConfig (asset) {
        return {
            url: `${this.projectHost}/projects/assets/${asset.assetId}.${asset.dataFormat}/`
        };
    }
    getAssetUpdateConfig (asset) {
        return `${this.projectHost}/projects/assets/${asset.assetId}.${asset.dataFormat}/`;
    }

    uploadAssets (assets) {
        const dirtyAssets = assets.filter(asset => !asset.clean);
        const dirtyAssetsConfig = dirtyAssets.map(item => ({
            type: 2,
            fileName: `${String(item.assetId).split('&&').pop()}.${item.dataFormat}`
        }));

        if (dirtyAssetsConfig.length <= 0) {
            return Promise.resolve();
        }

        return getOssSign({params: dirtyAssetsConfig})
            .then(res => dirtyAssets.map((item, index) => () => {
                const sign = res.data.data[index].sign;
                const leaf = `${String(item.assetId).split('&&').pop()}.${item.dataFormat}`;
                sign.fileName = leaf;
                return upload(
                    unit8ArryToFile(
                        item.data,
                        leaf,
                        item.assetType && item.assetType.contentType
                    ),
                    sign
                ).then(() => {
                    const keyNoExt = String(sign.dir || '').replace(/\.[^.]+$/, '');
                    if (keyNoExt.indexOf('/') !== -1) {
                        item.assetId = keyNoExt.replace(/\//g, '&&');
                    }
                    item.clean = true;
                });
            }))
            .then(res => batchToRun(res, 6));
    }

    /**
     * 把上传后 asset 上的路径编码 assetId 写回 costume/sound，
     * 否则 getAssetGetConfig / toJSON 仍可能按纯 md5 走 common/mit。
     */
    syncSerializedAssetIds (vm) {
        if (!vm || !vm.runtime || !vm.runtime.targets) return;
        vm.runtime.targets.forEach(target => {
            const costumes = (target.getCostumes && target.getCostumes()) ||
                (target.sprite && target.sprite.costumes) || [];
            costumes.forEach(costume => {
                if (costume.asset && costume.asset.assetId) {
                    costume.assetId = costume.asset.assetId;
                    const fmt = costume.dataFormat || costume.asset.dataFormat || 'png';
                    costume.md5 = `${costume.assetId}.${fmt}`;
                }
            });
            const sounds = (target.getSounds && target.getSounds()) ||
                (target.sprite && target.sprite.sounds) || [];
            sounds.forEach(sound => {
                if (sound.asset && sound.asset.assetId) {
                    sound.assetId = sound.asset.assetId;
                    const fmt = sound.dataFormat || sound.asset.dataFormat || 'wav';
                    sound.md5 = `${sound.assetId}.${fmt}`;
                }
            });
        });
    }

    /** 分享内容检测前：先上传脏资源并同步 assetId，避免误走 common/mit */
    ensureAssetsUploaded (vm) {
        if (!vm || !vm.assets) return Promise.resolve();
        return this.uploadAssets(vm.assets).then(() => {
            this.syncSerializedAssetIds(vm);
        });
    }

    //  * 上传分享接口
    //  * @param filePath url
    //  * @param fileName file name
    //  * @param dataFormat 日期, 如20180101
    //  * @returns {{url: string, withCredentials: boolean}} 格式
    getShareUpdateConfig (filePath, fileName, dataFormat) {
        return `${this.assetHost}/${filePath}/${fileName}.${dataFormat}`;
    }
    
    setTranslatorFunction (translator) {
        this.translator = translator;
        this.cacheDefaultProject();
    }
    cacheDefaultProject () {
        const defaultProjectAssets = defaultProject(this.translator);
        defaultProjectAssets.forEach(asset => this.builtinHelper._store(
            this.AssetType[asset.assetType],
            this.DataFormat[asset.dataFormat],
            asset.data,
            asset.id
        ));
    }

}

const storage = new Storage();

export default storage;
